import React from "react";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { Card, CardContent, Grid, TextField, Button, InputAdornment, IconButton  } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { replace, useNavigate } from "react-router-dom";
import { useState } from "react";
import AlertComp from "./Alert";
import { CookieSharp, Visibility, VisibilityOff } from '@mui/icons-material';
import { customerRegister } from "./api/api";
import axios from "axios";

function RegisterShortReport() {
  const navigate = useNavigate();
  // select field state
  const [birth, setBirth] = useState("10");
  const [firstname, setfirstname] = useState("");
  const [lastname, setlastname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("")
  const [userId, setUserId] = useState("")
  // select gender state
  const [gender, setGender] = useState("10");
  const [alertopen, setalertopen] = useState(false);
  const [alertmsg, setalertmsg] = useState('Test')

  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleChange = (event) => {
    setBirth(event.target.value);
  };

  const handleCustomerRegister = async () => {
    console.log(firstname, lastname, email, password,">>all details")
    if(!firstname || !lastname || !email || !password){
        setalertopen(true)
        setalertmsg('Please enter all the details')
        return;
    }
    let reqBody = {
        email: email,
        password: password,
        firstName: firstname,
        lastName: lastname
    };
    // setLoading(true);
    try {
      const response = await axios.post(customerRegister, reqBody);
      console.log(response,"::>>response>>")
    //   setLoading(false);
      if (response.status == 200) {
        const extractedUserId = response.data.userId.split('/').pop();
        console.log(extractedUserId,"::>>extractedUserId")
        setUserId(extractedUserId);
        localStorage.setItem("fname", firstname);
        localStorage.setItem("lname", lastname); 
        localStorage.setItem("userId", extractedUserId); 
        navigate("/resultnew");
      }
    } catch (error) {
        console.log(error, "Error")
    }
  }; 

  console.log(userId,"::>>userId>>")

  const handleGenderChange = (event) => {
    setGender(event.target.value);
  };

  function navigateTo() {
    setalertopen(true)
    if(!firstname || !lastname || !email || !password){
        setalertmsg('Please enter all the details')
        return;
    }
    localStorage.setItem("fname", firstname);
    localStorage.setItem("lname", lastname);
    navigate("/resultnew");
  }

  return (
    <div className="registerShortReport">
      <div className="pt-20px">
        <div className="d-flex justify-content-start align-items-center gap-10px">
          <span className="backButtonDiv mt-0px">
            <ArrowBackOutlinedIcon className="arrowBackBtn"></ArrowBackOutlinedIcon>
          </span>
          <h2 className="registerShortReportTitle">Register</h2>
        </div>
      </div>
      <div className="CommonMainCardReport">
        <Card className="mainCardInput mt-40px">
          <CardContent className="w-100">
            <Grid container spacing={2} className="mt-20px">
              <Grid item xs={12}>
                <TextField
                  id="outlined-basic"
                  label=""
                  variant="outlined"
                  placeholder="First Name"
                  className="mainInputField"
                  onChange={(e) => setfirstname(e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="outlined-basic"
                  label=""
                  variant="outlined"
                  placeholder="Last Name"
                  className="mainInputField"
                  onChange={(e) => setlastname(e.target.value)}
                />

                {/* <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={birth}
                                label="Birth"
                                onChange={handleGenderChange}
                                className="mainSelectField w-100"
                                >
                                <MenuItem value={10}>19/10/2000</MenuItem>
                                <MenuItem value={20}>Twenty</MenuItem>
                                <MenuItem value={30}>Thirty</MenuItem>
                                </Select> */}
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="outlined-basic"
                  type="email"
                  label=""
                  variant="outlined"
                  placeholder="Email Id"
                  className="mainInputField"
                  onChange={(e) => setEmail(e.target.value)}
                />

                {/* <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={gender}
                                label="Gender"
                                onChange={handleGenderChange}
                                className="mainSelectField w-100"
                                >
                                <MenuItem value={10}>Male</MenuItem>
                                <MenuItem value={20}>Female</MenuItem>
                               
                                </Select> */}
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="outlined-basic"
                //   type="password"
                type={showPassword ? 'text' : 'password'}
                  label=""
                  variant="outlined"
                  placeholder="Password"
                  className="mainInputField"
                  onChange={(e)=> setPassword(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClickShowPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>

            <div>
              <Button
                variant="contained"
                className="commonButton mt-40px"
                // onClick={() => navigateTo()}
                onClick={() => handleCustomerRegister()}
              >
                Submit
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
      <AlertComp open={alertopen} msg={alertmsg} type={"error"} />

    </div>
  );
}

export default RegisterShortReport;
